import { getCurrentDate } from "../threads/cpcoc/currentDate";
let nextRefresh;
// TODO: Can we use activeService?
// TODO: is this and activeService ever different?
export function setNextRefresh(refreshDate) {
    if (!nextRefresh ||
        (getCurrentDate() < refreshDate && refreshDate < nextRefresh)) {
        // if not defined set
        // OR if the date is in the future, AND the new proposed refresh time is closer than the last set
        nextRefresh = refreshDate;
    }
}
export function getNextRefresh() {
    return nextRefresh;
}
